import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import Admin from './Admin';
import Home from './Home';
import './styles.css';

export default function App() {
  return (
    <Router>
      {/* <nav style={{ marginBottom: '1rem' }}>
        <Link to="/">Accueil</Link> | <Link to="/admin">Admin</Link>
      </nav> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
